import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SolicitudesService } from '../../../services/solicitudes.service';
import { AuthService } from '../../../services/auth.service';

import { getIncialesMayuscula } from '../../../utils/utils';
import { RestriccionesService } from '../../../services/restricciones.service';

@Component({
  selector: 'app-form-hora',
  templateUrl: './form-hora.component.html',
  styleUrl: './form-hora.component.scss',
})
export class FormHoraComponent implements OnInit {
  _idRegistro: any;
  _idAprobador: any;
  _idRegistroAprobador: any;

  today: Date = new Date();
  fechaSalida: Date | null = null;
  horaInicio: string = '';
  horaFin: string = '';
  descripcion: string = '';
  horaRangoInvalido: boolean = false;
  esAprobador: boolean = false;
  esDetalle: boolean = false;
  esVista: boolean = false;
  estado: string = 'ENVIADO';
  estadoAprobador: string = '';

  modoEdicion: boolean = false;
  solicitudId: string | null = null;
  solicitud: any;
  observacion: string = '';
  restricciones: any;

  /*
   * Variables exclusivas para Excepción de Tickeo.
   * No afectan los demás formularios de hora.
   */
  esExcepcionTickeo: boolean = false;
  esPermisoConGoce: boolean = false;
  cargandoFechasTickeo: boolean = false;
  fechasTickeoCargadas: boolean = false;
  errorFechasTickeo: string = '';
  tipoJornadaTickeo: string = '';
  fechasPermitidasTickeo: Set<string> = new Set<string>();

  id_recursos_humanos: string = '695808c0a886da9f714a6945';

  RangoMinFecha = new Date(2026, 0, 1);
  RangoMaxFecha = new Date(2026, 11, 31);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<FormHoraComponent>,
    private authService: AuthService,
    private solicitudService: SolicitudesService,
    private restriccionService: RestriccionesService,
  ) {
    this._idRegistro = this.authService.getUserRegistro().toString();
    this._idAprobador = this.authService.getAprobador().toString();
  }

  ngOnInit(): void {
    this.esAprobador = this.data?.esAprobador ?? false;
    this.esDetalle = this.data?.esDetalle ?? false;
    this.esVista = this.data?.esVista ?? false;
    this.estadoAprobador = this.data?.estadoAprobador || 'PENDIENTE';
    this._idRegistroAprobador = this.data?._idRegistroAprobador;

    this.modoEdicion = this.data?.editar ?? false;

    if (this.modoEdicion && this.data?.id_contenido) {
      this.solicitud = this.data;
      this.estado = this.solicitud?.estado || 'ENVIADO';
      this.observacion = this.solicitud?.observacion || '';

      this.data = this.data.id_contenido;

      this.cargarDatosEdicion(this.solicitud);
    }

    this.restricciones = this.data?.restricciones || {};
    this.esExcepcionTickeo = this.esContenidoExcepcionTickeo();
    this.esPermisoConGoce = this.esContenidoPermisoConGoce();

    /*
     * Solo el funcionario que crea o modifica la solicitud
     * necesita consultar las fechas actuales.
     *
     * Los aprobadores y las vistas históricas conservan la fecha
     * original sin volver a validarla.
     */
   if (
  this.esExcepcionTickeo &&
  !this.esAprobador &&
  !this.esDetalle
) {
  this.cargarFechasPermitidasTickeo();
}
  }

  private esContenidoExcepcionTickeo(): boolean {
    const denominacion = String(this.data?.denominacion || '')
      .trim()
      .toUpperCase();

    if (denominacion === 'ET') {
      return true;
    }

    const titulo = String(this.data?.titulo || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toUpperCase();

    return titulo.includes('EXCEPCION DE TICKEO');
  }
private esContenidoPermisoConGoce(): boolean {
  const denominacion = String(this.data?.denominacion || '')
    .trim()
    .toUpperCase();

  return denominacion === 'CG';
}

  private cargarFechasPermitidasTickeo(): void {
    this.cargandoFechasTickeo = true;
    this.fechasTickeoCargadas = false;
    this.errorFechasTickeo = '';
    this.tipoJornadaTickeo = '';
    this.fechasPermitidasTickeo.clear();

    this.solicitudService.getFechasPermitidasTickeo().subscribe({
      next: (respuesta: any) => {
        const fechas = Array.isArray(respuesta?.fechas_permitidas)
          ? respuesta.fechas_permitidas
          : [];

        this.fechasPermitidasTickeo = new Set<string>(
          fechas.map((fecha: any) => String(fecha)),
        );

        this.tipoJornadaTickeo = respuesta?.tipo_jornada || '';
        this.cargandoFechasTickeo = false;

        if (fechas.length === 0) {
          this.fechasTickeoCargadas = false;
          this.errorFechasTickeo =
            'No se encontraron fechas habilitadas para la Excepción de Tickeo.';
          return;
        }

        this.fechasTickeoCargadas = true;
      },
      error: (error: any) => {
        this.cargandoFechasTickeo = false;
        this.fechasTickeoCargadas = false;

        this.errorFechasTickeo =
          error?.error?.mensaje ||
          'No se pudieron consultar las fechas habilitadas. Intente nuevamente.';
      },
    });
  }

  private formatearFechaLocal(fecha: Date): string {
    const anio = fecha.getFullYear();
    const mes = String(fecha.getMonth() + 1).padStart(2, '0');
    const dia = String(fecha.getDate()).padStart(2, '0');

    return `${anio}-${mes}-${dia}`;
  }

  private normalizarFecha(valor: any): string | null {
    if (!valor) {
      return null;
    }

    if (typeof valor === 'string') {
      const coincidencia = valor.match(/^(\d{4}-\d{2}-\d{2})/);

      if (coincidencia) {
        return coincidencia[1];
      }
    }

    const fecha = valor instanceof Date ? new Date(valor) : new Date(valor);

    if (Number.isNaN(fecha.getTime())) {
      return null;
    }

    return this.formatearFechaLocal(fecha);
  }

  private convertirAFechaLocal(valor: any): Date | null {
    if (!valor) {
      return null;
    }

    if (valor instanceof Date) {
      if (Number.isNaN(valor.getTime())) {
        return null;
      }

      return new Date(
        valor.getFullYear(),
        valor.getMonth(),
        valor.getDate(),
      );
    }

    if (typeof valor === 'string') {
      const coincidencia = valor.match(
        /^(\d{4})-(\d{2})-(\d{2})/,
      );

      if (coincidencia) {
        return new Date(
          Number(coincidencia[1]),
          Number(coincidencia[2]) - 1,
          Number(coincidencia[3]),
        );
      }
    }

    const fecha = new Date(valor);

    if (Number.isNaN(fecha.getTime())) {
      return null;
    }

    return new Date(
      fecha.getFullYear(),
      fecha.getMonth(),
      fecha.getDate(),
    );
  }

  private esFechaOriginalSeleccionada(fecha: Date): boolean {
    if (!this.modoEdicion || !this.solicitud?.fecha_inicio) {
      return false;
    }

    const fechaOriginal = this.normalizarFecha(
      this.solicitud.fecha_inicio,
    );

    const fechaEvaluada = this.formatearFechaLocal(fecha);

    return fechaOriginal === fechaEvaluada;
  }

  private esFechaPermitidaParaTickeo(fecha: Date): boolean {
    /*
     * Una solicitud antigua puede conservar su fecha original
     * aunque ya esté fuera del rango actual.
     */
    if (this.esFechaOriginalSeleccionada(fecha)) {
      return true;
    }

    if (
      this.cargandoFechasTickeo ||
      !this.fechasTickeoCargadas
    ) {
      return false;
    }

    const fechaTexto = this.formatearFechaLocal(fecha);

    return (
      this.fechasPermitidasTickeo.has(fechaTexto) &&
      this.estaEnRangoGestion(fecha)
    );
  }
private esFechaPermitidaParaPermisoConGoce(fecha: Date): boolean {
  /*
   * Durante una edición o revisión se conserva
   * la fecha original de la solicitud.
   */
  if (this.esFechaOriginalSeleccionada(fecha)) {
    return true;
  }

  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);

  const fechaMaximaPermitida = new Date(hoy);
  fechaMaximaPermitida.setDate(
    fechaMaximaPermitida.getDate() + 2,
  );
  fechaMaximaPermitida.setHours(0, 0, 0, 0);

  /*
   * Permite únicamente:
   * - hoy;
   * - mañana;
   * - pasado mañana.
   *
   * No excluye sábados, domingos ni feriados.
   */
  return (
    fecha >= hoy &&
    fecha <= fechaMaximaPermitida &&
    this.estaEnRangoGestion(fecha)
  );
}

  cargarDatosEdicion(solicitud: any): void {
    this.solicitudId = solicitud._id;

    this.fechaSalida = this.convertirAFechaLocal(
      solicitud.fecha_inicio,
    );

    this.horaInicio = solicitud.hora_inicio || '';
    this.horaFin = solicitud.hora_fin || '';
    this.descripcion = solicitud.detalle || '';
  }

  filtroFechasValidas = (fecha: Date | null): boolean => {
    if (!fecha) {
      return false;
    }

    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);

    const fechaSeleccionada = new Date(fecha);
    fechaSeleccionada.setHours(0, 0, 0, 0);

    /*
     * La fecha original se conserva durante una edición o revisión.
     * Esta comprobación debe estar antes de las reglas actuales.
     */
    if (this.esFechaOriginalSeleccionada(fechaSeleccionada)) {
      return true;
    }

    /*
     * Para Excepción de Tickeo, las fechas permitidas provienen
     * exclusivamente del backend.
     */
    if (this.esExcepcionTickeo) {
      return this.esFechaPermitidaParaTickeo(
        fechaSeleccionada,
      );
    }
/*
 * Permiso con Goce de Haber utiliza una regla independiente.
 * No consulta las fechas de Tickeo ni aplica días hábiles.
 */
if (this.esPermisoConGoce) {
  return this.esFechaPermitidaParaPermisoConGoce(
    fechaSeleccionada,
  );
}
    /*
     * Desde aquí se conserva la lógica anterior para todos
     * los demás contenidos y formularios.
     */
    const aplicarDiasHabiles =
      this.restricciones?.dias_habiles ?? false;

    if (aplicarDiasHabiles) {
      const nroDiaSemana = fechaSeleccionada.getDay();

      if (nroDiaSemana === 0 || nroDiaSemana === 6) {
        return false;
      }
    }

    const esFestivo =
      this.restricciones?.dias_no_permitidos?.some(
        (f: any) =>
          new Date(f).toDateString() ===
          fechaSeleccionada.toDateString(),
      );

    if (esFestivo) {
      return false;
    }

    const diaCierre =
      this.restricciones?.cierre_administrativo ?? 0;

    let fechaInicioPlanilla: Date | null = null;

    if (diaCierre > 0) {
      if (diaCierre >= 30) {
        fechaInicioPlanilla = new Date(
          hoy.getFullYear(),
          hoy.getMonth(),
          1,
        );

        if (
          hoy.getDate() > diaCierre &&
          fechaSeleccionada.getMonth() === hoy.getMonth()
        ) {
          return false;
        }
      } else {
        fechaInicioPlanilla =
          hoy.getDate() <= diaCierre
            ? new Date(
                hoy.getFullYear(),
                hoy.getMonth() - 1,
                diaCierre + 1,
              )
            : new Date(
                hoy.getFullYear(),
                hoy.getMonth(),
                diaCierre + 1,
              );
      }

      if (fechaSeleccionada < fechaInicioPlanilla) {
        return false;
      }
    }

    const plz =
      this.restricciones?.max_dias_plazo ?? 0;

    const ant =
      this.restricciones?.max_dias_anticipacion ?? 0;

    if (plz === 0 && ant === 0) {
      return this.estaEnRangoGestion(
        fechaSeleccionada,
      );
    }

    if (plz > 0) {
      const fechaMinimaPermitida =
        this.restriccionService.obtenerFechaMinimaPermitida(
          hoy,
          plz,
          this.restricciones,
        );

      const limiteRealAtras =
        fechaInicioPlanilla &&
        fechaMinimaPermitida < fechaInicioPlanilla
          ? fechaInicioPlanilla
          : fechaMinimaPermitida;

      if (fechaSeleccionada < limiteRealAtras) {
        return false;
      }
    } else if (plz < 0 && ant === 0) {
      if (fechaSeleccionada < hoy) {
        return false;
      }
    }

    if (ant > 0) {
      const fechaMinimaFutura =
        this.restriccionService.obtenerFechaMinimaFutura(
          hoy,
          ant,
          this.restricciones,
        );

      if (fechaSeleccionada < fechaMinimaFutura) {
        return false;
      }
    } else if (ant < 0) {
      const diasHaciaFuturo = Math.abs(ant);

      const fechaMaximaFutura =
        this.restriccionService.obtenerFechaMinimaFutura(
          hoy,
          diasHaciaFuturo,
          this.restricciones,
        );

      if (fechaSeleccionada > fechaMaximaFutura) {
        return false;
      }
    } else if (ant === 0 && plz > 0) {
      if (fechaSeleccionada > hoy) {
        return false;
      }
    } else if (ant === 0 && plz < 0) {
      return true;
    }

    return this.estaEnRangoGestion(
      fechaSeleccionada,
    );
  };

  private estaEnRangoGestion(fecha: Date): boolean {
    return (
      fecha >= this.RangoMinFecha &&
      fecha <= this.RangoMaxFecha
    );
  }

  validateHoraRango(): void {
    if (this.horaInicio && this.horaFin) {
      this.horaRangoInvalido =
        this.horaInicio >= this.horaFin;
    } else {
      this.horaRangoInvalido = false;
    }
  }

  enviarExcepcion(): void {
    if (this.fechaFueraDeRango()) {
      return;
    }

    /*
     * La validación del frontend solo ayuda al usuario.
     * El backend vuelve a validar la fecha antes de guardar.
     *
     * Los aprobadores no vuelven a validar fechas históricas.
     */
    if (this.esExcepcionTickeo && !this.esAprobador) {
      const fechaSeleccionada =
        this.convertirAFechaLocal(this.fechaSalida);

      if (this.cargandoFechasTickeo) {
        this.errorFechasTickeo =
          'Espere mientras se consultan las fechas habilitadas.';
        return;
      }

      if (
        !fechaSeleccionada ||
        !this.esFechaPermitidaParaTickeo(
          fechaSeleccionada,
        )
      ) {
        this.errorFechasTickeo =
          'La fecha seleccionada no está habilitada para Excepción de Tickeo.';
        return;
      }

      this.errorFechasTickeo = '';
    }

    if (
      !this.horaRangoInvalido &&
      this.fechaSalida &&
      this.horaInicio &&
      this.horaFin
    ) {
      const payload = {
        dias: [],
        gestion: new Date(),
        dias_totales: 0,
        fecha_inicio: this.fechaSalida,
        fecha_fin: this.fechaSalida,
        hora_inicio: this.horaInicio,
        hora_fin: this.horaFin,
        detalle: this.descripcion,
        observacion: this.observacion,
        id_registro: this._idRegistro,
        id_contenido: this.data?._id,
        id_cargo_aprobador: this._idAprobador,
        fecha_envio:
          this.data?.solicitud?.fecha_envio ||
          new Date(),
        estado: this.obtenerEstadoConfirmado(),
        esAprobador: this.esAprobador,
        nuevo_historial: null as any,
      };

      if (this.esAprobador) {
        payload.nuevo_historial = {
          id_registro: this._idRegistroAprobador,
          decision: this.estado,
          fecha: new Date(),
        };
      }

      if (this.modoEdicion && this.solicitudId) {
        this.solicitudService
          .updateSolicitud(
            this.solicitudId,
            payload,
          )
          .subscribe({
            next: (response) => {
              this.dialogRef.close(response);
            },
            error: (error: any) => {
              this.manejarErrorSolicitud(error);
            },
          });
      } else {
        this.solicitudService
          .addSolicitud(payload)
          .subscribe({
            next: (response) => {
              this.dialogRef.close(response);
            },
            error: (error: any) => {
              this.manejarErrorSolicitud(error);
            },
          });
      }
    }
  }

  private manejarErrorSolicitud(error: any): void {
    if (this.esExcepcionTickeo) {
      this.errorFechasTickeo =
        error?.error?.mensaje ||
        'No se pudo guardar la Excepción de Tickeo.';
    }

    console.error(
      'Error al guardar la solicitud:',
      error,
    );
  }

  obtenerEstadoConfirmado(): string {
    if (this.estado === 'DENEGADO') {
      return 'DENEGADO';
    }

    if (
      this._idAprobador ===
      this.id_recursos_humanos
    ) {
      return 'PENDIENTE';
    }

    return this.estado || 'ENVIADO';
  }

  setAction(
    action: 'APROBAR' | 'RECHAZO',
  ): void {}

  capitalizeFirst(text: string): string {
    return getIncialesMayuscula(text);
  }

  fechaFueraDeRango(): boolean {
    const fecha = this.convertirAFechaLocal(
      this.fechaSalida,
    );

    if (!fecha) {
      return true;
    }

    return (
      fecha < this.RangoMinFecha ||
      fecha > this.RangoMaxFecha
    );
  }

  observacionInvalida(): boolean {
    if (
      this.estado === 'RECHAZADO' ||
      this.estado === 'DENEGADO'
    ) {
      return (
        !this.observacion ||
        this.observacion.trim().length < 5
      );
    }

    return false;
  }

  salir(): void {
    this.dialogRef.close();
  }
}